export const OtherElement =  ()=>{
    return (
        <div className="container">
            カードを選択する際の条件を表します
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_other.png`}></img></p>
            上記の例では選択の際同名カード不可、全て選択を表示、左から選択を表示させています。
        </div>
    )
}
